import React from 'react';
import {
  Text,
  Image,
  Platform,
  View,
} from 'react-native';
import { WorkoutImportOrigin } from 'fitbeat.models';
import { SupportedConnectedApp } from './connected-workout-app';

export const getConnectedAppIcon = (
  app: SupportedConnectedApp | WorkoutImportOrigin | 'Fitillion',
  size: number,
) => {
  if (app === 'Apple Health' || app === 'apple-health') {
    return (
      <Image
        source={require('../assets/icons/apple-health.png')}
        style={{ width: size, height: size, resizeMode: 'contain' }}
      />
    );
  }
  if (app === 'Garmin Connect' || app === 'garmin-connect') {
    return (
      <Image
        source={ require('../assets/icons/garmin-connect.png') }
        style={{
          width: size,
          height: size,
          resizeMode: 'contain',
          transform: [{ scale: 0.9 }],
        }}
      />
    );
  }

  if (app === 'Health Connect' || app === 'android-health-connect') {
    return (
      <Image
        resizeMode='contain'
        style={{ width: size, height: size }}
        source={require('../assets/icons/health_connect_logo.png')}
      />
    );
  }

  if (app === 'Fitillion') {
    return (
      <Image
        source={require('../assets/icons/fitillion-star-black.png')}
        style={{ width: size, height: size, resizeMode: 'contain' }}
      />
    );
  }
  return (<Text>No Icon</Text>);
};
